import React from "react";

const ContactUsPage: React.FC = () => {
  return <div>ContactUsPage</div>;
};

export default ContactUsPage;
